"use strict";
export const useEnableFontScaling = (_allowFontScaling) => {
  return false;
};
